import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-303" data-mp="mz5vbfm4mugs">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-304" data-mp="rubpf1ponffy">
        <FadeIn data-id="element-305" data-mp="wqsato5hzfpc">
          <div className="space-y-2 md:space-y-4" data-id="element-306" data-mp="wteo84f2kpfh">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandGold font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandGold/40" data-id="element-307" data-mp="3va0ptrn0py7b">
              <span className="text-sm md:text-base" data-id="element-308" data-mp="90fz0274syth">🎨</span>
              <span className="text-[8.5px]" data-id="element-309" data-mp="e13x17ts2fx7">
                MEGAPACK COLORIMETRÍA LISTA™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[30px] md:text-[56px] leading-[1.08] tracking-[0.5px] text-txt-primary mx-auto max-w-[20ch] px-2 pt-3 pb-1" data-id="element-310" data-mp="1kgeaecps7wxv">
              <span className="block" data-id="element-311" data-mp="1h999bi4t88vl">CURSO COMPLETO</span>
              <span className="block text-brandGold" data-id="element-312" data-mp="1cb7r0zf7kdl6">DE COLORIMETRÍA MASCULINA.</span>
              <span className="block" data-id="element-313" data-mp="1c94oxh0s6u03">ORGANIZADO EN UN SOLO LUGAR.</span>
            </h1>

            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-314" data-mp="187t0vfxk2gu0">
              15 Módulos en Video · 4 Manuales Profesionales · 5 Bonos · Acceso inmediato
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-315" data-mp="tkhlt4260ep5">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-316" data-mp="tj6mbgfr5t3u">
            <div className="absolute inset-0 bg-brandGold/15 blur-[40px] rounded-full" data-id="element-317" data-mp="omoiqjw5s0t3"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[28px] rounded-full" data-id="element-318" data-mp="kkulymp33gy7"></div>
            <img src="https://cdn.magicpatterns.com/uploads/agacHF4oUprc8XhkQK75E2/mockup_sticker.png" alt="Megapack Colorimetría Lista — Mockup completo del producto" loading="eager" decoding="async" width={1000} height={1000}
          // @ts-ignore — supported by modern browsers
          fetchpriority="high" className="relative block w-full max-w-[300px] md:max-w-[560px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-319" data-mp="fjx307w92ivn" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-320" data-mp="3s5cb7hhmfqol">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-321" data-mp="3s6nelg75mwf6">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-322" data-mp="onubjxc05pz9">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-323" data-mp="9yxwvhffxepo">
                <span className="text-[10px] md:text-xs" data-id="element-324" data-mp="12nloduqs90bo">📄</span> 100% PDF +
                Videos HD
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-325" data-mp="17eljqvk97ac2">
                <span className="text-[10px] md:text-xs" data-id="element-326" data-mp="2n6fob0q6z8pt">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-327" data-mp="31t8vtjtgza7g">
                <span className="text-[10px] md:text-xs" data-id="element-328" data-mp="296eololny7bx">📚</span> 475+ páginas
                + 14 h de video
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-329" data-mp="2i7mcrdugtrsa">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-330" data-mp="2e4zf2wb45cn6">
                🎨 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-331" data-mp="3tnt11g98nv7v">
                <span className="flex items-center gap-1" data-id="element-332" data-mp="opf5mtr4cn2x">
                  <ShieldCheck size={11} className="text-success" data-id="element-333" data-mp="or042ugk0q62" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-334" data-mp="xpv7jys7rm5o">
                  <Lock size={11} className="text-txt-muted" data-id="element-335" data-mp="xoac86y2rz6r" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-336" data-mp="12pzqdvglgsz2">
                  <CreditCard size={11} className="text-brandGold" data-id="element-337" data-mp="17okrdx3o7gok" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'barberos dominan con esto'
  }, {
    value: '15',
    label: 'Módulos en video'
  }, {
    value: '4',
    label: 'Manuales PDF'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-338" data-mp="1ve5comnaqq10">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-339" data-mp="3fv4t8ir31ed6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-340" data-mp="3fwplu2tu6n8e">
          {stats.map((stat, i) => <FadeIn key={stat.label} delay={0.1 + i * 0.1} data-id="element-341" data-mp="3ayo3xl85ctyi" data-mpi={i}>
              <div className="font-display font-bold text-[30px] md:text-[42px] leading-[1.1] text-brandGold mb-0.5" data-id="element-342" data-mp="35y03ya1xx2s5">
                {stat.value}
              </div>
              <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-343" data-mp="2h1efkfqcm6a">
                {stat.label}
                {stat.star && <Star size={12} className="fill-gold text-gold" data-id="element-344" data-mp="3tnky7p3jnmgq" />}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'JM',
    text: 'No sabía como realizar platinados. Con esto aprendí como hacerlos. Me ayudo mucho, gracias.',
    author: 'Juan M.',
    role: 'Barbero Profesional · Argentina',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CS',
    text: 'Implemente el servicio de color con mi equipo. Ahora realizamos trabajos completos. Sin errores.',
    author: 'Carlos S.',
    role: 'Dueño de Barbería · México',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'RF',
    text: 'Descargué todo el curso. Ahora lo aplicamos en el local. Me ayudo mucho a comprender qué fórmula usar.',
    author: 'Roberto F.',
    role: 'Colorista · Colombia',
    bg: 'bg-brandGold text-[#14100A]'
  }];
  return <Section className="bg-bg-base" data-id="element-345" data-mp="1vz8promtpt7s">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-346" data-mp="1w0a1zwfkslr3">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-347" data-mp="1i0hesb39cnnv" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-348" data-mp="1myj0l3s2j131">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-349" data-mp="3cd7bf0l0gayy">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-350" data-mp="3hcjv5cgl51xb">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-351" data-mp="10qnap5i784l6">
                  <div className="flex text-gold mb-0.5" data-id="element-352" data-mp="10roo3gmot362">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-353" data-mp="1fft8qq5avorh" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-354" data-mp="1anj9gjiapccj">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-355" data-mp="1jgv6t3nhdurv">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-356" data-mp="1ybj9ka1hyf3s">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto pt-2.5" data-id="element-357" data-mp="40w3q6sq0oyh">
                Compró el Megapack
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Alguna vez realizaste un trabajo de color, utilizando fórmulas o técnicas, con información que encontraste por tu cuenta', 'Tienes dudas sobre la preparación exacta que necesitas para decolorar y neutralizar el cabello sin lastimarlo', 'Repites las mismas excusas porque no tienes la fórmula exacta para cada color', 'Un cliente nuevo pide un "platinado blanco" pero el trabajo te queda con reflejos amarillos', 'Conoces sobre el tema, pero no estás conforme con el resultado final por que sabes que puedes hacerlo mejor', 'Cada mes pierdes ingresos extras por rechazar trabajos o cobrarlos a un precio que no es rentable'];
  return <Section className="bg-bg-alt" data-id="element-358" data-mp="34f85pwo5s0om">
      <div className="max-w-[720px] mx-auto" data-id="element-359" data-mp="fmcpoqf79dwb">
        <FadeIn data-id="element-360" data-mp="fljftgky289y">
          <h2 className="font-display font-bold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25] tracking-[0.5px]" data-id="element-361" data-mp="fo5pblreaxut">
            Si eres  <span className="text-brandGold" data-id="element-362" data-mp="244no25vmbj64">barbero,</span>
            <br data-id="element-363" data-mp="2043ufca96xoq" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-364" data-mp="206846auu2qwx">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-365" data-mp="1vbkfobztxwic" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-366" data-mp="1lez9vofzkhdg" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-367" data-mp="1lcuv2bgjtxye">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Gold divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-368" data-mp="17fg1cuj9j40m"></div>

          <h3 className="font-display font-bold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2] tracking-[0.5px]" data-id="element-369" data-mp="31tqpf0s19u5c">
            ¿Sigues improvisando{' '}
            <span className="text-brandGold inline-block" style={{
            textShadow: '0 0 20px rgba(212,162,76,0.5), 0 0 40px rgba(212,162,76,0.3)'
          }} data-id="element-370" data-mp="dcttrsirvnhz">
             por tener un conocimiento disperso?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-371" data-mp="mdrmvfroaals">
            <p style={{
            paddingLeft: "10px"
          }} data-id="element-372" data-mp="3utbeybglxmz9">
              Elegiste este camino porque amás esta profesión, trabajar en la imagen de las personas y ganar dinero en serio.
            </p>
            <p style={{
            paddingLeft: "9px"
          }} data-id="element-373" data-mp="8fjxbswyubkn">
              Pero nadie te dijo que ibas a perder tiempo y dinero, improvisando con tus clientes, intentando descubir EL SECRETO EXACTO que utilizan los barbéros: dónde TODO esté organizado, donde NO FALLES y
              puedas COBRAR lo que realmente vale tu trabajo.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandGold rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(212,162,76,0.2)]" data-id="element-374" data-mp="1rc52d9r2vmks">
            <p className="font-display font-bold text-[18px] md:text-[26px] leading-[1.3] text-center text-txt-primary uppercase tracking-[0.5px]" data-id="element-375" data-mp="1dmbd4qbnv0aj">
              ¿Y SI HOY TUVIERAS TODO LISTO PARA{' '}
              <span className="text-brandGold" data-id="element-376" data-mp="269xfjv95jyvt">DOMINAR LA TÉCNICA?</span>
            </p>
          </div>

          {/* Gold divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-377" data-mp="1wbrgdleqd6un"></div>
        </FadeIn>
      </div>
    </Section>;
};